export function setDashboardBorrowerCount (state, payload) {
  state.dashboardBorrowerCount = payload
}

export function setDashboardLoanAmount (state, payload) {
  state.dashboardLoanAmount = payload
}

export function setDashboardOutstandingAmount (state, payload) {
  state.dashboardOutstandingAmount = payload
}

export function setDashboardProsecutionCount (state, payload) {
  state.dashboardProsecutionCount = payload
}

export function setDashboardLoanSpending (state, payload) {
  state.dashboardLoanSpending = payload
}

export function setDashboardPaymentDue (state, payload) {
  state.dashboardPaymentDue = payload
}

export function setDashboardDebtTracking (state, payload) {
  state.dashboardDebtTracking = payload
}

export function setDashboardStageAgings (state, payload) {
  state.dashboardStageAgings = payload
}

export function setDashboardBorrowers (state, payload) {
  state.dashboardBorrowers = payload
}

export function setDashboardLoanAmountBorrowers (state, payload) {
  state.dashboardLoanAmountBorrowers = payload
}

export function setDashboardOutstandingRemainBorrowers (state, payload) {
  state.dashboardOutstandingRemainBorrowers = payload
}

export function setDashboardProsecutionBorrowers (state, payload) {
  state.dashboardProsecutionBorrowers = payload
}

export function setDashboardStageAgingNormalBorrowers (state, payload) {
  state.dashboardStageAgingNormalBorrowers = payload
}

export function setDashboardStageAgingAllBorrowers (state, payload) {
  state.dashboardStageAgingAllBorrowers = payload
}

export function setDashboardStageAging1Borrowers (state, payload) {
  state.dashboardStageAging1Borrowers = payload
}

export function setDashboardStageAging2Borrowers (state, payload) {
  state.dashboardStageAging2Borrowers = payload
}

export function setDashboardStageAging3Borrowers (state, payload) {
  state.dashboardStageAging3Borrowers = payload
}

export function setDashboardLoanSpendingBorrowers (state, payload) {
  state.dashboardLoanSpendingBorrowers = payload
}

export function setDashboardPaymentDueBorrowers (state, payload) {
  state.dashboardPaymentDueBorrowers = payload
}

export function setDashboardFollowUpBorrowers (state, payload) {
  state.dashboardFollowUpBorrowers = payload
}

export function setDashboardMonthlyPaymentHistories (state, payload) {
  state.dashboardMonthlyPaymentHistories = payload
}
